import { render, staticRenderFns } from "./MedicationPrescriptionInputSelect.vue?vue&type=template&id=1bb203d6&scoped=true"
import script from "./MedicationPrescriptionInputSelect.vue?vue&type=script&lang=js"
export * from "./MedicationPrescriptionInputSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb203d6",
  null
  
)

export default component.exports